import React from "react";

function WhatIsArbitrageT() {
  return (
    <>
      <div className="container p-5">
        <div
          className="pricing-style-one-item-cos bg-dark text-light"
          style={{
            backgroundImage:
              "url(https://validthemes.net/site-template/robok/assets/img/shape/10.png)",
          }}
        >
          <div className="text-center">
            <h3>What is an Arbitrage Trading Bot?</h3>
            <div className="bottom">
              <div className="pricing">
                <p>
                  An arbitrage crypto trading bot is an automated software tool
                  designed to take advantage of price differences for the same
                  cryptocurrency on different exchanges. Arbitrage opportunities
                  arise when a cryptocurrency is priced higher on one exchange
                  than on another. The bot identifies these price discrepancies,
                  buys the crypto at a lower price from one exchange, and sells
                  it at a higher price on another, earning a profit from the
                  difference.
                </p>
              </div>
              <a className="btn btn-style-one mt-30" href="#">
                Get Started
              </a>
            </div>
          </div>
          {/* <div className="right-info"></div> */}
        </div>
      </div>
    </>
  );
}

export default WhatIsArbitrageT;
